import { SentryInstance } from './instance';

export const getTraceHeaders = () => {
  const trace = SentryInstance.getTraceData();
  return {
    baggage: trace.baggage,
    'sentry-trace': trace['sentry-trace'],
  };
};
